import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import {
  getOpportunityMSServiceListDataByOMSId,
  updateMasterServiceInOpportunityMSServices,
} from '../opportunityMSServices/mockData'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getOpportunityMasterServiceListData,
  getPotentialLocationSelectItemListDataByOMSId,
  getCompanyDataByOpportunityMasterServiceId,
  getSupplierListDataByOpportunityMasterServiceId,
  propagateOpportunityMasterServiceAdditions,
  propagateOpportunityMasterServiceChanges,
  propagateOpportunityMasterServiceDeletions,
} from './mockData'
import type { ICompany } from '~/types/company/models'
import { IEntitySelectItemWithOptionalAvatar } from '~/types/models'

// async function getOpportunityMasterServices(
//   req: RestRequest,
//   res: ResponseFunction,
//   ctx: RestContext
// ) {
//   console.log(`'Returning opportunitymasterservices.`)
//   return res(ctx.status(200), ctx.json({ items: getOpportunityMasterServiceListData() }))
// }

async function getPotentialLocations(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(
    `'Returning potential locations for service of opportunityMasterService id ${id}.`
  )
  return res(
    ctx.status(200),
    ctx.json({
      data: await getPotentialLocationSelectItemListDataByOMSId(id),
    })
  )
}

interface GetCompanyFromOpportunityMasterServiceResponse {
  data: ICompany
}

async function getCompanyFromOpportunityMasterService(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetCompanyFromOpportunityMasterServiceResponse = {
      data: await getCompanyDataByOpportunityMasterServiceId(id), // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e: unknown) {
    const responseBody = {
      statusCode: 404,
      message: `Can't get Company from opportunityMasterService ${id}: ${e.message}`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

interface GetSuppliersFromOpportunityMasterServiceResponse {
  data: IEntitySelectItemWithOptionalAvatar[]
}

async function getSuppliersFromOpportunityMasterService(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  // Mirrors WXTG/cynque-api-server#1816: suppliers with an msService that
  // "Assign to Contract(s)" could take. Status 6 used to be the filter, and
  // now means already assigned.
  const onlyWithAssignableMSServices =
    req.url.searchParams.get('onlywithassignablemsservices') === 'true'
  try {
    const responseBody: GetSuppliersFromOpportunityMasterServiceResponse = {
      data: await getSupplierListDataByOpportunityMasterServiceId(
        id,
        onlyWithAssignableMSServices
      ),
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e: unknown) {
    const responseBody = {
      statusCode: 404,
      message: `Can't get Suppliers from opportunityMasterService ${id}: ${e.message}`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

async function getOpportunityMSServicesByOMSId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`'Returning opportunityMSServices for opportunity "${id}".`)
  const data = await getOpportunityMSServiceListDataByOMSId(id) // may be empty array. That's a valid response.
  return res(ctx.status(200), ctx.json({ data }))
}

// post

const postOpportunityMasterService = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getOpportunityMasterServiceListData,
    undefined,
    propagateOpportunityMasterServiceAdditions
  )
}

const patchOpportunityMasterService = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getOpportunityMasterServiceListData,
    [
      updateMasterServiceInOpportunityMSServices,
      propagateOpportunityMasterServiceChanges,
    ]
  )
}

const deleteOpportunityMasterServices = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getOpportunityMasterServiceListData,
    undefined,
    propagateOpportunityMasterServiceDeletions
  )
}

export const handlers = [
  // {
  //   method: 'get',
  //   path: '/api/opportunitymasterservices',
  //   handler: getOpportunityMasterServices,
  // },
  {
    method: 'get',
    path: '/api/opportunitymasterservices/:id/potentiallocations',
    handler: getPotentialLocations,
  },
  {
    method: 'get',
    path: '/api/opportunitymasterservices/:id/company',
    handler: getCompanyFromOpportunityMasterService,
  },
  {
    method: 'get',
    path: '/api/opportunitymasterservices/:id/suppliers',
    handler: getSuppliersFromOpportunityMasterService,
  },
  {
    method: 'get',
    path: '/api/opportunitymasterservices/:id/opportunitymsservices',
    handler: getOpportunityMSServicesByOMSId,
  },
  {
    method: 'post',
    path: '/api/opportunitymasterservices',
    handler: postOpportunityMasterService,
  },
  {
    method: 'patch',
    path: '/api/opportunitymasterservices/:id',
    handler: patchOpportunityMasterService,
  },
  {
    method: 'delete',
    path: '/api/opportunitymasterservices/:id',
    handler: deleteOpportunityMasterServices,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
